import React from 'react';

import VerticalBar from './VerticalBar';
import HorizontalBar from './HorizontalBar';

export default class Bar extends React.Component {
  static Vertical = VerticalBar;
  static Horizontal = HorizontalBar;
}
